import React, { useState } from "react";
import Reset from '../components/Authentication/Reset';

export default function ForgetPassword() {
  return (
    <Reset />
  );
}
